module.exports = __webpack_public_path__ + "static/img/company-13.24146f33.png";